import { Icon, Spinner } from '@fluentui/react';
import React, { useEffect } from 'react';
import { useRetrievingCredential } from './useRetrievingCredential';
import { ICredentialError } from './Credential.type';
import { useTelemetry } from '@iamexperiences/ecos-telemetry';
import { getVerifyIdErrorString } from '../../shared/getErrorString';
import { useLocalization } from '@microsoft/portal-app/lib/shared/localization';
import { useAuth } from '@iamexperiences/feature-auth';
import { VERIFIEDID_APP_NAME_LINKEDIN } from '../../shared/constants';

interface IRetrievingCredentialsProps {
  appName: string;
}

const retrievingCredentialStyle = require('./RetrievingCredentials.scoped.scss');

export const RetrievingCredentials: React.FC<IRetrievingCredentialsProps> = ({ appName }) => {
  const [t] = useLocalization('Account');
  const { auth } = useAuth();
  const telemetry = useTelemetry();
  const retrievingCredentialMutation = useRetrievingCredential();

  const isError = retrievingCredentialMutation.isError;

  useEffect(() => {
    if (retrievingCredentialMutation.data) {
      if (appName?.toLowerCase() === VERIFIEDID_APP_NAME_LINKEDIN.toLowerCase()) {
        window.location.href = `${appName}://openid-vc?url=${encodeURIComponent(
          retrievingCredentialMutation.data.url,
        )}`;
      } else {
        // Default behavior is currently not part of any scenario
        window.location.href = retrievingCredentialMutation.data.url;
      }
    }
  }, [appName, retrievingCredentialMutation.data, retrievingCredentialMutation.isSuccess]);

  useEffect(() => {
    // photo is optional, we just need to wait that request complete
    retrievingCredentialMutation.mutate();
  }, []);

  useEffect(() => {
    if (isError) {
      telemetry.error('getCredential', retrievingCredentialMutation.error);
    }
  }, [retrievingCredentialMutation.error, retrievingCredentialMutation.isError, isError, t, telemetry]);

  return (
    <div className={retrievingCredentialStyle.loadingContainer}>
      {!isError && <Spinner label={t('retrievingCredentials')} ariaLive="assertive" labelPosition="right" />}
      {isError && (
        <div>
          <Icon iconName="Warning" />{' '}
          {getVerifyIdErrorString(
            t,
            (retrievingCredentialMutation.error as ICredentialError)?.type,
            auth.user?.tenantId,
          )}
        </div>
      )}
    </div>
  );
};
